module.exports = __webpack_public_path__ + "static/ref-design-1259274ab494a83eb1b44994c303a2d3.png";